import React from 'react';
import "../../styles/App.css";
import { TopBar } from "../top_bar";

const SATResources = () => {
  return (
    <div>
      <div className="content">
        <main>
          <header>
            <h1>SAT study resources</h1>
          </header>
          <p>Coming soon.</p>
        </main>
      </div>
      <TopBar />
    </div>
  );
};

export default SATResources;
